import { Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
  const logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex alignItems="center" flexDirection="column">
      <Text
        my="32px"
        fontSize="lg"
        fontWeight="800"
        color={logoColor}
        letterSpacing="-0.02em"
        textAlign="center"
        px="10px"
      >
        Income & Expense
      </Text>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
